import { render, staticRenderFns } from "./footer-slider.vue?vue&type=template&id=04a30244&scoped=true&"
import script from "./footer-slider.vue?vue&type=script&lang=js&"
export * from "./footer-slider.vue?vue&type=script&lang=js&"
import style0 from "./footer-slider.vue?vue&type=style&index=0&id=04a30244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a30244",
  null
  
)

export default component.exports